import {useSyncExternalStore} from 'react';

import {isRequesting, subscribeToRequests} from '../helpers/axios-helper';

/** Whether any request to the API is underway. */
export const useRequesting = (): boolean => useSyncExternalStore(subscribeToRequests, isRequesting);
